import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const selectClass = "h-10 rounded-md border border-input bg-background px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export function SearchFilters({ statuses, clients, showArchivedToggle = false, placeholder = "Search..." }) {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const archived = params.get("archived") === "1";

  function setParam(key, value) {
    const np = new URLSearchParams(params);
    if (value) np.set(key, value);
    else np.delete(key);
    np.delete("page");
    setParams(np);
  }

  useEffect(() => {
    const t = setTimeout(() => {
      if ((params.get("q") || "") !== q) setParam("q", q);
    }, 350);
    return () => clearTimeout(t);
  }, [q]);

  const hasFilters = !!params.get("q") || !!params.get("status") || !!params.get("client") || archived;

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative">
        <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} className="w-64 pl-9" />
      </div>
      {statuses && (
        <select value={params.get("status") || ""} onChange={(e) => setParam("status", e.target.value)} className={selectClass}>
          <option value="">All statuses</option>
          {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      )}
      {clients && clients.length > 0 && (
        <select value={params.get("client") || ""} onChange={(e) => setParam("client", e.target.value)} className={selectClass}>
          <option value="">All organizations</option>
          {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      )}
      {showArchivedToggle && (
        <label className="flex h-10 cursor-pointer items-center gap-2 rounded-md border border-input bg-background px-3 text-sm" data-testid="show-archived-toggle">
          <input
            type="checkbox"
            checked={archived}
            onChange={(e) => setParam("archived", e.target.checked ? "1" : "")}
            className="h-4 w-4 cursor-pointer accent-rose-600"
          />
          Show archived
        </label>
      )}
      {hasFilters && (
        <Button variant="ghost" size="sm" onClick={() => { setQ(""); setParams(new URLSearchParams()); }}>
          <X className="h-4 w-4" /> Clear
        </Button>
      )}
    </div>
  );
}
